/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SectionHeader } from '../Shared/SectionHeader'
import { Section } from '../Shared/Section'
import { MonthlyPositiveActivityCard } from './Cards/MonthlyPositiveActivityCard'
import { TodayPositiveActivityCard } from './Cards/TodayPositiveActivityCard/TodayPositiveActivityCard'
import { useTranslation } from 'react-i18next'
import { MissedRevenueCard } from './Cards/MissedRevenueCard/MissedRevenueCard'
import { MissedRevenueCard as MissedRevenueCardV2 } from './Cards/MissedRevenueCardV2/MissedRevenueCard'

const BusinessPerformanceSection = () => {
    const [t] = useTranslation()

    return (
      <>
          <SectionHeader title={t('dashboard.business_performance')} />

          <Section>
              <TodayPositiveActivityCard/>
              <MonthlyPositiveActivityCard/>
              <div css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 1rem;
                  
                  @media (max-width: 1300px) {
                      flex-direction: row;
                  }
                  
                  @media (max-width: 900px) {
                      flex-direction: column;
                  }
              `}>
                  <MissedRevenueCard />
              </div>
              {/* <MissedRevenueCard /> */}
          </Section>
      </>
    )
}

export { BusinessPerformanceSection }
